import { createApp } from 'vue';
import App from './index.vue';
import 'uno.css';
const app = createApp(App);
app.mount('#app');
